import React from 'react';

import { withTranslation } from 'providers/GILT.provider';

import ActivityFeedIcon from 'activity/components/ActivityFeedIcon';
import Footer from 'activity/components/ItemFooter';

export class MissedCall extends React.Component {
  markAsRead = () => {
    this.props.onReadToggle(!this.props.seen);
  };
  nameList = (phone) => {
    const names = [];
    if (phone) {
      this.props.clients.forEach((client) => {
        if (client.phone === phone) {
          names.push(client.user_name);
        }
      });
    }
    return names;
  };
  mapPhoneToNames = (phone) => {
    const { t } = this.props;
    const names = this.nameList(phone);
    if (!names.length) {
      return t('composite.activityFeed.missedCall.unknownPhone', { phoneNumber: phone });
    }
    if (names.length === 1) {
      return t('composite.activityFeed.missedCall.knownPhone', {
        user: names[0],
        phoneNumber: phone,
      });
    }

    return t('composite.activityFeed.missedCall.guessPhone', {
      phoneNumber: phone,
      user1: names.slice(0, names.length - 1).join(', '),
      user2: names[names.length - 1],
    });
  };
  render() {
    const { t } = this.props;
    const names = this.nameList(this.props.number);
    let actionText = '';
    switch (this.props.outcome) {
      case 'user_closed':
        actionText = t('composite.activityFeed.missedCall.closedCall');
        break;
      default:
        actionText = this.mapPhoneToNames(this.props.number);
        break;
    }
    return (
      //  MissedCall  is a separate file, it is necessary to create a type  to display it
      <div className="comment-content 3 sidebar-message-wrap">
        <div className="feed-text missed-call">
          <span
            className="label-name-call"
            onClick={() => this.props.callNumber(this.props.number)}
            role="button"
            tabIndex="0"
          >
            {t('composite.activityFeed.missedCall.call')}
            <div className={!this.props.seen ? 'new-item-indicator available' : 'new-item-indicator'} />
          </span>
          <div
            className="client-name text-cap"
            onClick={() => this.props.callNumber(this.props.number)}
            role="button"
            tabIndex="0"
          >
            <ActivityFeedIcon iconName="ico-mutu" />
            {names.length === 1 ? names[0] : this.props.number}
          </div>
          <div className="additional-info">
            <span className="received-text">{actionText}</span>
          </div>
        </div>
        <Footer seen={this.props.seen} markAsRead={this.markAsRead} timestamp={this.props.timestamp} />
      </div>
    );
  }
}

const MissedCallHoc = withTranslation()(MissedCall);

export default MissedCallHoc;
